export default "__VITE_ASSET__DJo5vF2x__"